export default __webpack_public_path__ + "static/media/NIE_touchpoint_06.137c0291.mp4";